import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleTheme}
      aria-label={t(theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode')}
      className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-[#FF43A7]/40 tw-bg-transparent tw-text-[#FF43A7] tw-transition-all hover:tw-bg-[#FF43A7]/15 tw-cursor-pointer"
    >
      <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} className="tw-text-base" />
    </button>
  );
}

export default ThemeToggle;
